module.exports = __webpack_public_path__ + "static/assets/40d93a6df1b5ae71423bdcb7c0622f0e.svg";